export default __webpack_public_path__ + "static/media/background.5e61feb7.jpg";